import { topicItems } from '@/mocks/homeData';

const trendIcons: Record<string, { icon: string; color: string }> = {
  up: { icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  hot: { icon: 'ri-fire-line', color: 'text-accent-500' },
  new: { icon: 'ri-sparkling-line', color: 'text-accent-500' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">全网最热影视话题实时追踪</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex flex-wrap gap-2 md:gap-3 justify-center">
            {topicItems.map((item) => {
              const trend = trendIcons[item.trend];
              const rankColors = item.rank <= 3
                ? 'bg-primary-500 text-white'
                : 'bg-secondary-200 text-foreground-600';
              return (
                <a
                  key={item.id}
                  href="#cards"
                  className="inline-flex items-center gap-2 px-3 py-2 md:px-4 md:py-2.5 rounded-full bg-background-100 border border-secondary-200 hover:border-primary-300 hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
                >
                  <span className={`w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold ${rankColors}`}>
                    {item.rank}
                  </span>
                  <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{item.name}</span>
                  <span className="flex items-center gap-0.5">
                    <i className={`${trend.icon} ${trend.color} text-xs w-3 h-3 flex items-center justify-center`}></i>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
                  </span>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}